/**
 * Pulse snapshots for Lyncs Neo (web immersive) — aligned with full Pulse Overview layout.
 */

/** Key metrics row — structure like Address Cafe Pulse Overview */
export const PULSE_NEO_KPIS = [
  {
    id: 'sales',
    label: 'Net Sales',
    value: 'SAR 2,768',
    sublabel: 'Avg daily / store',
    change: '+12.4%',
    up: true,
  },
  {
    id: 'tx',
    label: 'Transactions',
    value: '151',
    sublabel: 'Avg ticket SAR 18.3',
    change: '+5.2%',
    up: true,
  },
  {
    id: 'cust',
    label: 'Customer Count',
    value: '5',
    sublabel: 'Returning rate 42%',
    change: '+3.1%',
    up: true,
  },
  {
    id: 'peak',
    label: 'Peak Hour Sales',
    value: '199',
    sublabel: '21:00 – 22:00',
    change: '+8.0%',
    up: true,
  },
  {
    id: 'partner',
    label: 'Partner Sales',
    value: '250',
    sublabel: 'Orders · delivery & agg.',
    change: '+11.2%',
    up: true,
  },
];

export const PULSE_NEO_LIVE = {
  todaySales: 1458932,
  activeStores: 94,
  totalStores: 100,
  peakHour: { time: '21:00 – 22:00', sales: 199 },
};

/** Hourly-style buckets (compressed day) for Neo chart */
export const PULSE_NEO_HOURLY = [
  { h: '6a', sales: 90, tx: 6 },
  { h: '8a', sales: 240, tx: 18 },
  { h: '10a', sales: 380, tx: 28 },
  { h: '12p', sales: 450, tx: 34 },
  { h: '2p', sales: 420, tx: 31 },
  { h: '4p', sales: 400, tx: 29 },
  { h: '6p', sales: 460, tx: 33 },
  { h: '8p', sales: 520, tx: 38 },
  { h: '9p', sales: 580, tx: 42 },
  { h: '10p', sales: 199, tx: 19 },
];

export const PULSE_NEO_PAYMENT_BREAKDOWN = [
  { id: 'card', label: 'Card', value: 'SAR 1,842', pct: 58, color: '#6366f1' },
  { id: 'cash', label: 'Cash', value: 'SAR 612', pct: 19, color: '#10b981' },
  { id: 'agg', label: 'Aggregator', value: 'SAR 489', pct: 15, color: '#06b6d4' },
  { id: 'coup', label: 'Coupon', value: 'SAR 156', pct: 5, color: '#f59e0b' },
  { id: 'meal', label: 'Employee meals', value: 'SAR 84', pct: 3, color: '#ec4899' },
];

export const PULSE_NEO_DISTRIBUTION_TOTAL = 'SAR 3,183,504';

export const PULSE_NEO_PRODUCTS = [
  { id: 1, name: 'Ethiopian Black GOLD', category: 'Coffee', sales: 'SAR 428' },
  { id: 2, name: 'Iced Spanish Latte', category: 'Cold', sales: 'SAR 392' },
  { id: 3, name: 'Flat White', category: 'Coffee', sales: 'SAR 356' },
  { id: 4, name: 'Date Cake Slice', category: 'Pastry', sales: 'SAR 298' },
  { id: 5, name: 'Cold Brew Nitro', category: 'Cold', sales: 'SAR 267' },
];

export const PULSE_NEO_STAFF = [
  { id: 1, name: 'Hussam', sales: 'SAR 612', tx: '34' },
  { id: 2, name: 'Ansari', sales: 'SAR 589', tx: '31' },
  { id: 3, name: 'Nora', sales: 'SAR 534', tx: '29' },
  { id: 4, name: 'Khalid', sales: 'SAR 498', tx: '27' },
  { id: 5, name: 'Sara', sales: 'SAR 445', tx: '24' },
];

export const PULSE_NEO_STORES_RANK = [
  { id: 1, name: 'Jeddah — Al Manar', city: 'Jeddah', sales: 'SAR 890' },
  { id: 2, name: 'Riyadh — Olaya', city: 'Riyadh', sales: 'SAR 834' },
  { id: 3, name: 'Khobar — Fanateer', city: 'Eastern', sales: 'SAR 798' },
  { id: 4, name: 'Jeddah — Red Sea Mall', city: 'Jeddah', sales: 'SAR 756' },
  { id: 5, name: 'Riyadh — RDC', city: 'Riyadh', sales: 'SAR 701' },
];

export const PULSE_NEO_REVENUE_WEEK = [
  { day: 'Mon', bar: 420, line: 118 },
  { day: 'Tue', bar: 480, line: 125 },
  { day: 'Wed', bar: 510, line: 132 },
  { day: 'Thu', bar: 445, line: 120 },
  { day: 'Fri', bar: 620, line: 148 },
  { day: 'Sat', bar: 580, line: 142 },
  { day: 'Sun', bar: 460, line: 128 },
];

export const PULSE_NEO_TOP_STORES = [
  { id: 1, name: 'Riyadh Gallery', location: 'Riyadh', sales: 'SAR 892K', growth: '+15.8%' },
  { id: 2, name: 'Red Sea Mall', location: 'Jeddah', sales: 'SAR 784K', growth: '+12.4%' },
  { id: 3, name: 'Dhahran Mall', location: 'Dhahran', sales: 'SAR 682K', growth: '+9.2%' },
  { id: 4, name: 'Al Nakheel Mall', location: 'Riyadh', sales: 'SAR 579K', growth: '+8.7%' },
  { id: 5, name: 'Al Rashid Mall', location: 'Dammam', sales: 'SAR 493K', growth: '+7.5%' },
];

export const PULSE_NEO_TREND_MONTHS = [
  { month: 'Jan', sales: '412M', tx: '3.4M' },
  { month: 'Feb', sales: '428M', tx: '3.5M' },
  { month: 'Mar', sales: '445M', tx: '3.6M' },
  { month: 'Apr', sales: '438M', tx: '3.55M' },
  { month: 'May', sales: '451M', tx: '3.62M' },
  { month: 'Jun', sales: '468M', tx: '3.7M' },
];

export const PULSE_NEO_ANALYTICS_MIX = [
  { id: 'a1', label: 'Food & Beverage', pct: 34, color: '#ec4899' },
  { id: 'a2', label: 'Fashion & Apparel', pct: 28, color: '#8b5cf6' },
  { id: 'a3', label: 'Electronics', pct: 18, color: '#06b6d4' },
  { id: 'a4', label: 'Home & Living', pct: 12, color: '#f59e0b' },
  { id: 'a5', label: 'Other', pct: 8, color: '#64748b' },
];

export const PULSE_NEO_REGIONS = [
  { id: 'riyadh', name: 'Riyadh Region', stores: 28, sales: 'SAR 2.45B', growth: '+15.2%' },
  { id: 'eastern', name: 'Eastern Province', stores: 25, sales: 'SAR 1.95B', growth: '+11.8%' },
  { id: 'makkah', name: 'Makkah Region', stores: 22, sales: 'SAR 1.85B', growth: '+12.4%' },
  { id: 'asir', name: 'Asir Region', stores: 14, sales: 'SAR 980M', growth: '+9.1%' },
];

export const PULSE_NEO_COMPARISON = [
  { metric: 'Net sales', today: 'SAR 1.46M', yesterday: 'SAR 1.29M', lastWeek: 'SAR 1.37M' },
  { metric: 'Transactions', today: '12,567', yesterday: '11,234', lastWeek: '11,987' },
  { metric: 'Customers', today: '10,982', yesterday: '9,876', lastWeek: '10,432' },
  { metric: 'Avg ticket', today: 'SAR 116', yesterday: 'SAR 115', lastWeek: 'SAR 114' },
  { metric: 'Conversion', today: '45.2%', yesterday: '43.8%', lastWeek: '44.5%' },
];

export const PULSE_NEO_RANKINGS = {
  regional: [
    { rank: 1, name: 'Ahmed Al-Saud', scope: 'Riyadh Region', value: 'SAR 2.45B', yoy: '+15.2%' },
    { rank: 2, name: 'Khalid Al-Otaibi', scope: 'Eastern Province', value: 'SAR 1.95B', yoy: '+11.8%' },
    { rank: 3, name: 'Faisal Al-Zahrani', scope: 'Makkah Region', value: 'SAR 1.85B', yoy: '+12.4%' },
  ],
  district: [
    { rank: 1, name: 'Mohammed Al-Qahtani', scope: 'North Riyadh', value: 'SAR 980M', yoy: '+18.5%' },
    { rank: 2, name: 'Omar Al-Dosari', scope: 'Central Riyadh', value: 'SAR 892M', yoy: '+14.2%' },
  ],
  store: [
    { rank: 1, name: 'Sara Al-Rashid', scope: 'Riyadh Gallery', value: 'SAR 156M', yoy: '+22.4%' },
    { rank: 2, name: 'Nora Al-Mutairi', scope: 'Red Sea Mall', value: 'SAR 142M', yoy: '+19.1%' },
  ],
};

export const PULSE_NEO_PERF = {
  headline: 'Trailing 12 months · consolidated',
  rows: [
    { label: 'Total sales', value: 'SAR 5.42B', delta: '+12.4%', up: true },
    { label: 'Transactions', value: '44.2M', delta: '+9.8%', up: true },
    { label: 'Avg ticket', value: 'SAR 123', delta: '+2.1%', up: true },
    { label: 'Customer visits', value: '38.9M', delta: '+11.2%', up: true },
    { label: 'Sales / staff hour', value: 'SAR 1,675', delta: '+6.3%', up: true },
    { label: 'Sales / m²', value: 'SAR 342', delta: '+4.9%', up: true },
  ],
};
